import { PLACEHOLDER_IMG_URL } from '../../../constants/images';

const ZONE_THUMBNAIL_URL_BASE = 'https://cdn.uppbeat.io/video/zone-thumbnails/';

export const getZoneThumbnailUrl = (thumbnailFile: string) => {
  try {
    return new URL(thumbnailFile, ZONE_THUMBNAIL_URL_BASE).toString();
  } catch {
    return PLACEHOLDER_IMG_URL;
  }
};
